import { i18n } from "@/plugins/i18n";

export default [
      {
        path: "finance",
        name: "account.finance",
        component: () => import("@/views/Finance/Finance"),
        redirect: { name: "account.finance.analytics" },
        meta: {
          pageTitle: "Finance",
          rule: "owner",
        },
        children: [
          {
            path: "analytics",
            component: () => import("@/views/Finance/FinanceAnalytics"),
            name: "account.finance.analytics",
            meta: {
              pageTitle: i18n.t("route.page_title.account.finance.analytics"),
              parent: "account.finance",
              rule: "owner",
            },
          },
        ],
      },
    ];
